/** Numeric onboarding step ↔ semantic screen id ↔ slide component. */

export const ONBOARDING_SCREEN_IDS = [
  "narrative_1",
  "narrative_2",
  "narrative_3",
  "narrative_4",
  "benefits",
  "setup_screen_time",
  "setup_overlay",
  "vpn_setup",
] as const;

export type OnboardingScreenId = (typeof ONBOARDING_SCREEN_IDS)[number];

/** iOS/web omit Android-only overlay permission; Android includes it after Usage Access. */
export function getOnboardingScreenSequence(includeOverlay: boolean): OnboardingScreenId[] {
  if (includeOverlay) return [...ONBOARDING_SCREEN_IDS];
  return ONBOARDING_SCREEN_IDS.filter((id) => id !== "setup_overlay");
}

export function getOnboardingTotalSteps(includeOverlay: boolean): number {
  return getOnboardingScreenSequence(includeOverlay).length;
}

/** @deprecated Prefer getOnboardingTotalSteps(includeOverlay) — kept for call sites that assume iOS/web length. */
export const ONBOARDING_TOTAL_STEPS = 7;

export function stepToScreenId(step: number, includeOverlay = false): OnboardingScreenId {
  const sequence = getOnboardingScreenSequence(includeOverlay);
  const index = Math.max(1, Math.min(sequence.length, step)) - 1;
  return sequence[index]!;
}

export function screenIdToStep(screenId: OnboardingScreenId, includeOverlay = false): number {
  const sequence = getOnboardingScreenSequence(includeOverlay);
  const index = sequence.indexOf(screenId);
  return index >= 0 ? index + 1 : 0;
}
